module.exports = __webpack_public_path__ + "img/solution-icon-4.b904e853.png";